import { useEffect } from 'react';

export const useThirdPartyCookies = () => {
  useEffect(() => {
    // Suppress third-party cookie warnings
    localStorage.setItem('cookieWarning', 'seen');
    
    // You can add more cookie-related settings here
    // For example, if you're using Google Analytics, Firebase, etc.
    
    return () => {
      // Cleanup if needed
    };
  }, []);
};